// EditCareerProfilePopup.jsx

import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axiosClient from "../api/axiosClient";
import Swal from "sweetalert2";
import "../styles/UserProfile.css";

const UserProfile = ({ isOpen, onClose }) => {
  const [careerData, setCareerData] = useState(null);
  // ADD THIS STATE
  const [userDetails, setUserDetails] = useState(null)

  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  // add state on top with other useState
  const [firstNameError, setFirstNameError] = useState("");
  // add state on top with other useState
  const [lastNameError, setLastNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  //if (!isOpen) return null;
  useEffect(() => {
    if (isOpen) {
      getCareerProfile();
      getDetailsProfile()
    }
  }, [isOpen]);

  // Lock background scroll while the popup is open
  useEffect(() => {
    if (isOpen) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [isOpen]);

  const getCareerProfile = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axiosClient.get("/auth/getCareerProfile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Career Profile:", res.data);

      setCareerData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  // ADD THIS NEW API FUNCTION

  const getDetailsProfile = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axiosClient.get("/auth/getDetailsProfile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("User Details:", res.data);

     setUserDetails({
  ...res.data.data,
  lastName: res.data.data.lastName || "",
});
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveChanges = async () => {
    try {
      if (newPassword || oldPassword || confirmPassword) {
        if (!oldPassword) {
          Swal.fire({
            icon: "warning",
            title: "Validation Error",
            text: "Please enter old password",
          });
          return;
        }

        if (newPassword !== confirmPassword) {
          Swal.fire({
            icon: "error",
            title: "Password Mismatch",
            text: "New Password and Confirm Password do not match",
          });
          return;
        }
      }
    if (
  firstNameError ||
  lastNameError ||
  mobileError ||
  !userDetails?.fullName?.trim() ||
  String(userDetails?.mobileNo || "").length !== 10
) {
  return;
}
      setLoading(true);

      const token = localStorage.getItem("token");

      const payload = {
        firstName: userDetails?.fullName || "",
        lastName: userDetails?.lastName?.trim() || "",
        mobileNo: userDetails?.mobileNo || "",
        oldPassword: oldPassword || null,
        newPassword: newPassword || null,
        targetCompany:
          careerData?.targetCompany === "Other"
            ? customInputs.targetCompany
            : careerData?.targetCompany,
        targetRole:
          careerData?.targetRole === "Other"
            ? customInputs.targetRole
            : careerData?.targetRole,
        preparationDeadlineMonths:
          careerData?.preparationDeadlineMonths || null,
        priorCodingExperience:
          careerData?.priorCodingExperience === "Other"
            ? customInputs.priorCodingExperience
            : careerData?.priorCodingExperience,
        dailyCodingHours:
          careerData?.dailyCodingHours === "Other"
            ? Number(customInputs.dailyCodingHours)
            : Number(careerData?.dailyCodingHours),
        nonTechBackground:
          careerData?.nonTechBackground || false,
        currentEducation:
          careerData?.currentEducation === "Other"
            ? customInputs.currentEducation
            : careerData?.currentEducation,
        preferredLanguage:
          careerData?.preferredLanguage === "Other"
            ? customInputs.preferredLanguage
            : careerData?.preferredLanguage,
      };

      const res = await axiosClient.post(
        "/auth/update/userDetailsAndCareerProfile",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Profile Updated Successfully",
      });
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");

      console.log(res.data);

      onClose();

    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };
  const [customInputs, setCustomInputs] = useState({
    targetCompany: "",
    targetRole: "",
    priorCodingExperience: "",
    currentEducation: "",
    dailyCodingHours: "",
    preferredLanguage: "",
  });
  if (!isOpen) return null;

  const data = [
    {
      title: "Target Company",
      value: careerData?.targetCompany || "",
      desc: "The company you want to join",
    },
    {
      title: "Target Role",
      value: careerData?.targetRole || "",
      desc: "The role you are aiming for",
    },
    {
      title: "Coding Experience",
      value: careerData?.priorCodingExperience || "",
      desc: "Your current coding level",
    },
    {
      title: "Education",
      value: careerData?.currentEducation || "",
      desc: "Your highest education",
    },
    {
      title: "Daily Coding Hours",
      value: careerData?.dailyCodingHours || "",
      desc: "Time you should code daily",
    },
    {
      title: "Preferred Language",
      value: careerData?.preferredLanguage || "",
      desc: "Your preferred coding language",
    },
    {
      title: "Background",
      value: careerData?.nonTechBackground ? "Non Tech" : "Tech",
      desc: "Your education background",
    },
    {
      title: "Preparation Deadline",
      value: `${careerData?.preparationDeadlineMonths || ""} Months`,
      desc: "Time you have to prepare",
    },
  ];

  const companyOptions = [
    "Google",
    "Microsoft",
    "Amazon",
    "Meta",
    "Apple",
    "Netflix",
    "Adobe",
    "Flipkart",
    "Uber",
    "TCS",
    "Other",
  ];

  const roleOptions = [
    "Frontend Developer",
    "Backend Developer",
    "Full Stack Developer",
    "Other",
  ];

  const codingOptions = [
    "Basic",
    "Intermediate",
    "Advanced",
    "Other",
  ];

  const educationOptions = [
    "B.Tech",
    "M.Tech",
    "BCA",
    "MCA",
    "BSc",
    "MSc",
    "Other",
  ];

  const hoursOptions = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6+",
    "Other",
  ];

  const backgroundOptions = [
    "IT",
    "Non-IT",
  ];

  const languageOptions = [
    "JavaScript",
    "Python",
    "Java",
    "C++",
    "C",
    "Other",
  ];


const passwordInvalid =
  (oldPassword || newPassword || confirmPassword) &&
  (
    !oldPassword ||
    !newPassword ||
    !confirmPassword ||
    newPassword !== confirmPassword
  );

const isFormInvalid =
  loading ||
  !!firstNameError ||
  !!lastNameError ||
  !!mobileError ||
  !userDetails?.fullName?.trim() ||
  String(userDetails?.mobileNo || "").length !== 10 ||
  passwordInvalid;

  const popupContent = (
    <div className="up-overlay" onMouseDown={onClose}>
      <div className="up-popup" onMouseDown={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="up-header">
          <div>
            <h1 className="up-title">Edit Career Profile</h1>
            <p className="up-subtitle">
              Update your career profile and goals
            </p>
          </div>
          <div className="up-close-btn" onClick={onClose}>
            ✕
          </div>
        </div>

        {/* FORM */}
        <div className="up-form-grid">
          <div>
            <label className="up-label">First Name</label>
            <input
              className="up-input"
              value={userDetails?.fullName || ""}
              onChange={(e) => {
                const value = e.target.value;

                if (value.length <= 50) {
                  setUserDetails({
                    ...userDetails,
                    fullName: value,
                  });

                  setFirstNameError("");
                } else {
                  setFirstNameError("First Name cannot exceed 50 characters");
                }
              }}
            />

            {firstNameError && (
              <p className="up-error-text">{firstNameError}</p>
            )}
          </div>

          <div>
            <label className="up-label">Last Name</label>
            <input
              className="up-input"
              value={userDetails?.lastName || ""}
              onChange={(e) => {
                const value = e.target.value;

                if (value.length <= 50) {
                  setUserDetails({
                    ...userDetails,
                    lastName: value,
                  });

                  setLastNameError("");
                } else {
                  setLastNameError("Last Name cannot exceed 50 characters");
                }
              }}
            />

            {lastNameError && (
              <p className="up-error-text">{lastNameError}</p>
            )}
          </div>

          <div>
            <label className="up-label">Mobile Number</label>
            <input
              className="up-input"
              value={userDetails?.mobileNo || ""}
              onChange={(e) => {
                const value = e.target.value;

                // only numbers allowed
                if (!/^\d*$/.test(value)) {
                  setMobileError("Only numbers are allowed");
                  return;
                }

                // max 10 digits
                if (value.length > 10) {
                  setMobileError("Mobile Number cannot exceed 10 digits");
                  return;
                }

                setUserDetails({
                  ...userDetails,
                  mobileNo: value,
                });

                // less than 10 digits
                if (value.length > 0 && value.length < 10) {
                  setMobileError("Mobile Number must be 10 digits");
                } else {
                  setMobileError("");
                }
              }}
            />

            {mobileError && (
              <p className="up-error-text">{mobileError}</p>
            )}
          </div>

          <div>
            <label className="up-label">Email</label>
            <input className="up-input"
              value={userDetails?.email}
              readOnly />
          </div>

          <div>
            <label className="up-label">Old Password</label>
            <input className="up-input"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            />
          </div>

          <div>
            <label className="up-label">New Password</label>
            <input className="up-input"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div>
            <label className="up-label">Confirm Password</label>
            <input className="up-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
        </div>

        {/* INFO BOXES */}
        <div className="up-info-grid">
          {data.map((item, index) => (
            <div key={index} className="up-box">

              <h3 className="up-box-title">{item.title}</h3>

              {item.title === "Target Company" ? (
                <>
                  <select
                    className="up-select"
                    value={careerData?.targetCompany || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      setCareerData({
                        ...careerData,
                        targetCompany: value,
                      });

                      // reset custom input if not "Other"
                      if (value !== "Other") {
                        setCustomInputs({ ...customInputs, targetCompany: "" });
                      }
                    }}
                  >
                    {companyOptions.map((company, i) => (
                      <option key={i} value={company}>
                        {company}
                      </option>
                    ))}
                  </select>
                  {careerData?.targetCompany === "Other" && (
                    <input
                      className="up-select"
                      style={{ marginTop: "10px" }}
                      placeholder="Enter company name"
                      value={customInputs.targetCompany}
                      onChange={(e) =>
                        setCustomInputs({
                          ...customInputs,
                          targetCompany: e.target.value,
                        })
                      }
                    />
                  )}
                </>
              ) : item.title === "Target Role" ? (
                <>
                  <select
                    className="up-select"
                    value={careerData?.targetRole || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      setCareerData({
                        ...careerData,
                        targetRole: value,
                      });

                      // reset custom input if not "Other"
                      if (value !== "Other") {
                        setCustomInputs({
                          ...customInputs,
                          targetRole: "",
                        });
                      }
                    }}
                  >
                    {roleOptions.map((role, i) => (
                      <option key={i} value={role}>
                        {role}
                      </option>
                    ))}
                  </select>

                  {careerData?.targetRole === "Other" && (
                    <input
                      className="up-select"
                      style={{ marginTop: "10px" }}
                      placeholder="Enter role"
                      value={customInputs.targetRole}
                      onChange={(e) =>
                        setCustomInputs({
                          ...customInputs,
                          targetRole: e.target.value,
                        })
                      }
                    />
                  )}
                </>
              ) : item.title === "Coding Experience" ? (

                <>
                  <select
                    className="up-select"
                    value={careerData?.priorCodingExperience || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      setCareerData({
                        ...careerData,
                        priorCodingExperience: value,
                      });

                      // reset custom input if not "Other"
                      if (value !== "Other") {
                        setCustomInputs({
                          ...customInputs,
                          priorCodingExperience: "",
                        });
                      }
                    }}
                  >
                    {codingOptions.map((level, i) => (
                      <option key={i} value={level}>
                        {level}
                      </option>
                    ))}
                  </select>

                  {careerData?.priorCodingExperience === "Other" && (
                    <input
                      className="up-select"
                      style={{ marginTop: "10px" }}
                      placeholder="Enter your coding level"
                      value={customInputs.priorCodingExperience}
                      onChange={(e) =>
                        setCustomInputs({
                          ...customInputs,
                          priorCodingExperience: e.target.value,
                        })
                      }
                    />
                  )}
                </>

              ) : item.title === "Education" ? (

                <>
                  <select
                    className="up-select"
                    value={careerData?.currentEducation || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      setCareerData({
                        ...careerData,
                        currentEducation: value,
                      });

                      // reset custom input if not "Other"
                      if (value !== "Other") {
                        setCustomInputs({
                          ...customInputs,
                          currentEducation: "",
                        });
                      }
                    }}
                  >
                    {educationOptions.map((edu, i) => (
                      <option key={i} value={edu}>
                        {edu}
                      </option>
                    ))}
                  </select>

                  {careerData?.currentEducation === "Other" && (
                    <input
                      className="up-select"
                      style={{ marginTop: "10px" }}
                      placeholder="Enter your education"
                      value={customInputs.currentEducation}
                      onChange={(e) =>
                        setCustomInputs({
                          ...customInputs,
                          currentEducation: e.target.value,
                        })
                      }
                    />
                  )}
                </>

              ) : item.title === "Daily Coding Hours" ? (

                <>
                  <select
                    className="up-select"
                    value={careerData?.dailyCodingHours || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      setCareerData({
                        ...careerData,
                        dailyCodingHours: value,
                      });

                      // reset custom input if not "Other"
                      if (value !== "Other") {
                        setCustomInputs({
                          ...customInputs,
                          dailyCodingHours: "",
                        });
                      }
                    }}
                  >
                    {hoursOptions.map((hour, i) => (
                      <option key={i} value={hour}>
                        {hour}
                      </option>
                    ))}
                  </select>

                  {careerData?.dailyCodingHours === "Other" && (
                    <input
                      className="up-select"
                      style={{ marginTop: "10px" }}
                      placeholder="Enter hours (e.g. 7)"
                      value={customInputs.dailyCodingHours}
                      onChange={(e) =>
                        setCustomInputs({
                          ...customInputs,
                          dailyCodingHours: e.target.value,
                        })
                      }
                    />
                  )}
                </>
              ) : item.title === "Preferred Language" ? (

                <>
                  <select
                    className="up-select"
                    value={careerData?.preferredLanguage || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      setCareerData({
                        ...careerData,
                        preferredLanguage: value,
                      });

                      // reset custom input if not "Other"
                      if (value !== "Other") {
                        setCustomInputs({
                          ...customInputs,
                          preferredLanguage: "",
                        });
                      }
                    }}
                  >
                    {languageOptions.map((lang, i) => (
                      <option key={i} value={lang}>
                        {lang}
                      </option>
                    ))}
                  </select>

                  {careerData?.preferredLanguage === "Other" && (
                    <input
                      className="up-select"
                      style={{ marginTop: "10px" }}
                      placeholder="Enter preferred language"
                      value={customInputs.preferredLanguage}
                      onChange={(e) =>
                        setCustomInputs({
                          ...customInputs,
                          preferredLanguage: e.target.value,
                        })
                      }
                    />
                  )}
                </>
              ) : item.title === "Background" ? (

                <select
                  className="up-select"
                  value={careerData?.nonTechBackground ? "Non-IT" : "IT"}
                  onChange={(e) =>
                    setCareerData({
                      ...careerData,
                      nonTechBackground: e.target.value === "Non-IT",
                    })
                  }
                >
                  {backgroundOptions.map((bg, i) => (
                    <option key={i} value={bg}>
                      {bg}
                    </option>
                  ))}
                </select>
              ) : item.title === "Preparation Deadline" ? (

                <input
                  className="up-select"
                  value={`${careerData?.preparationDeadlineMonths || ""} Months`}
                  readOnly
                />
              ) : (

                <select className="up-select">
                  <option>{item.value}</option>
                </select>
              )}

              <p className="up-box-desc">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* BUTTON */}
        <div className="up-btn-wrap">
          <button
            className="up-button"
            onClick={handleSaveChanges}
            disabled={isFormInvalid}
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );

  // Render via portal directly into document.body so this modal always
  // centers in the viewport, regardless of any transformed/positioned
  // ancestor (e.g. navbar animations) that would otherwise break
  // `position: fixed` centering.
  return createPortal(popupContent, document.body);
};

export default UserProfile;